import { render, staticRenderFns } from "./ConfiguredButtons.vue?vue&type=template&id=63df9c07&scoped=true"
import script from "./ConfiguredButtons.vue?vue&type=script&lang=js"
export * from "./ConfiguredButtons.vue?vue&type=script&lang=js"
import style0 from "./ConfiguredButtons.vue?vue&type=style&index=0&id=63df9c07&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63df9c07",
  null
  
)

export default component.exports